export default {
    name: "pagination",
    template: '#vue-paginate',
    data() {
        return {
            currentPage: this.page,
        }
    },

    props: {
        pages: [String, Number],
        page: [String, Number]
    },

    watch: {
        page(newVal, oldVal) {
            this.currentPage = this.page
        }
    },
}